var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"user-info"},[(_vm.user)?_c('div',{staticClass:"user-info__wrap"},[_c('user-info-header'),_c('user-data'),_c('user-contact'),(false)?[(_vm.isDistributor || _vm.isProfessional)?_c('user-comment'):_vm._e()]:_vm._e(),_c('userChangePassword')],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }